import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Login from './pages/Login';
import Home from './pages/Home';
import NewAddress from './pages/NewAddress';
import Layout from './components/Layout';
import Pod from './pages/Pod'
import NewSchool from './pages/NewSchool';
import DeliveryRoute from './pages/DeliveryRoute';
import MealTypeRoute from './pages/MealTypeScreen'
import MealTypeScreen from './pages/MealTypeScreen';
import MenuScreen from './pages/MenuScreen';
import SubItemScreen from './pages/SubItemScreen';
import CustomerMenuScreen from './pages/CustomerMenuScreen';
import PlanTypeScreen from './pages/PlanTypeScreen';
import Plandetail from './pages/PlanScreen';
import { Toaster } from 'react-hot-toast';
import PlanHolidaysScreen from './pages/PlanHolidaysScreen';

const App = () => {
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);

  return (
    
    <Router>
        <Toaster position="top-right" />
      <Routes>
        {/* Public login route */}
        <Route path="/" element={isLoggedIn ? <Navigate to="/home" /> : <Login />} />
      
        {/* Protected routes inside Layout */}  
        {isLoggedIn && (
          <>
            <Route
              path="/home"
              element={
                <Layout>
                  <Home />
                </Layout>
              }
            />
            <Route
              path="/addresses/new"
              element={
                <Layout>
                  <NewAddress />
                </Layout>
              }
            />

            <Route path="/pods/new"  element={
                <Layout>
                  <Pod />
                </Layout>
              } />

            <Route
              path="/schools/new"
              element={
                <Layout>
                  <NewSchool />
                </Layout>
              }
            />


            <Route
              path="/deliveryroute/new"
              element={
                <Layout>
                  <DeliveryRoute />
                </Layout>
              }
            />

            <Route
              path="/mealtype/new"
              element={
                <Layout>
                  <MealTypeScreen />
                </Layout>
              }
            />



            <Route
              path="/menu/new"
              element={
                <Layout>
                  <MenuScreen />
                </Layout>
              }
            />



          <Route
              path="/subitem/new"
              element={
                <Layout>
                  <SubItemScreen />
                </Layout>
              }
            />

          <Route
              path="/weeklymenu/new"
              element={
                <Layout>
                  <CustomerMenuScreen />
                </Layout>
              }
            />


            <Route
              path="/plantype/new"
              element={
                <Layout>
                  <PlanTypeScreen />
                </Layout>
              }
            />

            <Route
              path="/plandetail/new"
              element={
                <Layout>
                  <Plandetail />
                </Layout>
              }
            />

          <Route
              path="/planholidays/new"
              element={
                <Layout>
                  <PlanHolidaysScreen />
                </Layout>
              }
            />




          </>
        )}

        {/* Catch-all route: redirect to login if not found */}
        <Route path="*" element={<Navigate to={isLoggedIn ? "/home" : "/"} />} />
      </Routes>
    </Router>
  );
};

export default App;
